import { render, staticRenderFns } from "./AutoDeleteDialog.vue?vue&type=template&id=cfc4b9b4&scoped=true"
import script from "./AutoDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./AutoDeleteDialog.vue?vue&type=script&lang=ts"
import style0 from "./AutoDeleteDialog.vue?vue&type=style&index=0&id=cfc4b9b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc4b9b4",
  null
  
)

export default component.exports